import type { SecuritySearchResult } from '../api/types'
import { countryLabel } from './ResearchCurrency'

/** Use source identifiers for navigation; tickers keep their original spelling and leading zeros. */
export function companyAnalysisHref(company: Pick<SecuritySearchResult, 'company_code' | 'ticker'>) {
  return company.company_code
    ? `/analyze/${encodeURIComponent(company.company_code)}`
    : `/analyze?ticker=${encodeURIComponent(company.ticker)}`
}

export function companyMeta(company: SecuritySearchResult) {
  return [...new Set([countryLabel(company.country), company.ticker, company.company_code, company.industry, company.market].filter(Boolean))].join(' · ')
}

export function companyFilingsHref(code: string, country?: string | null, from?: string) {
  const params = new URLSearchParams({ company: code })
  if (country) params.set('country', country)
  if (from) params.set('from', from)
  return `/filings?${params}`
}
